import { useCallback, useEffect, useRef } from 'react';

export const useFixedScroll = () => {
    const scrollPosRef = useRef<number>(0);
    const rafIdRef = useRef<number | null>(null);

    const handleScroll = useCallback((event: React.UIEvent<HTMLElement>) => {
        const target = event.target as HTMLElement;
        if (rafIdRef.current !== null) {
            cancelAnimationFrame(rafIdRef.current);
        }
        rafIdRef.current = requestAnimationFrame(() => {
            scrollPosRef.current = target.scrollTop;
        });
    }, []);

    useEffect(() => {
        return () => {
            if (rafIdRef.current !== null) {
                cancelAnimationFrame(rafIdRef.current);
            }
        };
    }, []);

    return {
        scrollPosition: scrollPosRef.current,
        handleScroll,
    };
};
